import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Ruta {
  id: string;
  tab: string;
  nombre: string;
  distancia: string;
  desnivel: string;
  certificado: string;
  vueltas: string;
  detalleVueltas?: string;
  salida: string;
  llegada: string;
  mapa: string; // imagen del mapa de la ruta (en /public)
  certificadoImg: string; // imagen del certificado (en /public)
}

// Datos tomados de los certificados oficiales World Athletics – AIMS.
const RUTAS: Ruta[] = [
  {
    id: "21k",
    tab: "21K",
    nombre: "21K · Media Maratón",
    distancia: "21.0975 km",
    desnivel: "0.28 m/km",
    certificado: "ECU2026-070",
    vueltas: "9 vueltas al circuito: 1 vuelta circuito rojo, 7 vueltas circuito azul y 1 vuelta circuito amarillo.",
    detalleVueltas:
      "Circuito Rojo: 2.62199 km · Circuito Azul: 7 × 2.35324 km · Circuito Amarillo: 1.94451 km · reajuste de salida 58.5 m · Total: 21.0975 km.",
    salida:
      "Av. Montalvo, al frente de la puerta principal del Laboratorio Clínico (columna Este de la puerta azul). Ancho de vía 7 m, dirección Este.",
    llegada:
      "Av. Montalvo y 16 de Diciembre, en el inicio del paso cebra sentido Oeste-Este, en el Parque Montalvo. Ancho de vía 7 m.",
    mapa: "/recorrido-21k.jpg",
    certificadoImg: "/certificado-21k.jpg",
  },
  {
    id: "5k",
    tab: "5K",
    nombre: "5K · Carrera",
    distancia: "5 km",
    desnivel: "0.60 m/km",
    certificado: "ECU2026-069",
    vueltas: "2 vueltas al circuito: 1.ª vuelta circuito rojo, 2.ª vuelta circuito azul.",
    detalleVueltas: "1.ª vuelta: 2.62199 km · 2.ª vuelta: 2.21326 km · reajuste de salida 164.75 m · Total: 5 km.",
    salida:
      "Av. Montalvo entre Eloy Alfaro y Thomas Halflants, frente al restaurante de comida rápida Mariane. Ancho de vía 7 m, dirección Este.",
    llegada:
      "Av. Montalvo y 16 de Diciembre, esquina en el inicio del paso cebra sentido Oeste-Este, en el Parque Montalvo. Ancho de vía 7 m.",
    mapa: "/recorrido-5k.jpg",
    certificadoImg: "/certificado-5k.jpg",
  },
  {
    id: "milla",
    tab: "Milla",
    nombre: "1 Milla · Urbana",
    distancia: "1.609344 km",
    desnivel: "1.86 m/km",
    certificado: "ECU2026-068",
    vueltas: "Circuito lineal (un solo tramo).",
    salida:
      "Av. Montalvo entre Eloy Alfaro y Thomas Halflants, en el restaurante Tigrillo y Bolón (junto al generador de energía eléctrica). Ancho de vía 7 m.",
    llegada:
      "Av. Montalvo y 16 de Diciembre, al inicio del paso peatonal, dirección Oeste-Este, en el Parque Montalvo. Ancho de vía 7 m.",
    mapa: "/recorrido-milla.jpg",
    certificadoImg: "/certificado-milla.jpg",
  },
];

export default function RecorridoPage() {
  const [activa, setActiva] = useState(RUTAS[0].id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const ruta = RUTAS.find((r) => r.id === activa)!;
  const cardClass = "bg-white rounded-2xl shadow-sm p-5 md:p-6";

  return (
    <div className="min-h-screen bg-background-50">
      {/* Encabezado */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center overflow-hidden">
              <img
                src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png"
                alt="Logo Baños Run"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-heading text-lg md:text-xl tracking-wide text-foreground-950">BAÑOS RUN 2026</span>
          </Link>
          <Link
            to="/"
            className="px-4 py-2 rounded-full border border-primary-500 text-primary-500 text-sm font-semibold hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            ← Inicio
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-6 md:py-10 space-y-5">
        <div className="text-center">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">RECORRIDOS</h1>
          <p className="text-sm text-foreground-600 mt-1">
            Circuitos certificados por World Athletics &amp; AIMS · Baños de Agua Santa · 18 de Julio 2026
          </p>
        </div>

        {/* Pestañas de distancia */}
        <div className="flex justify-center gap-2 flex-wrap">
          {RUTAS.map((r) => (
            <button
              key={r.id}
              onClick={() => setActiva(r.id)}
              className={`px-6 py-2 rounded-full text-sm font-semibold transition-colors ${
                activa === r.id
                  ? "bg-primary-500 text-white"
                  : "bg-white text-foreground-700 border border-foreground-200 hover:bg-primary-50"
              }`}
            >
              {r.tab}
            </button>
          ))}
        </div>

        {/* Contenido de la ruta activa */}
        <section className={cardClass}>
          <h2 className="font-heading text-2xl text-primary-600 mb-4">{ruta.nombre}</h2>

          {/* Datos certificados */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
            <div className="bg-background-50 rounded-xl p-3 text-center">
              <p className="text-xs text-foreground-500">Distancia</p>
              <p className="font-semibold text-foreground-900">{ruta.distancia}</p>
            </div>
            <div className="bg-background-50 rounded-xl p-3 text-center">
              <p className="text-xs text-foreground-500">Desnivel</p>
              <p className="font-semibold text-foreground-900">{ruta.desnivel}</p>
            </div>
            <div className="bg-background-50 rounded-xl p-3 text-center">
              <p className="text-xs text-foreground-500">Grado WA</p>
              <p className="font-semibold text-foreground-900">A</p>
            </div>
            <div className="bg-background-50 rounded-xl p-3 text-center">
              <p className="text-xs text-foreground-500">Certificado</p>
              <p className="font-semibold text-foreground-900">{ruta.certificado}</p>
            </div>
          </div>

          {/* Mapa de la ruta */}
          <img
            src={ruta.mapa}
            alt={`Mapa del recorrido ${ruta.nombre}`}
            className="w-full rounded-xl border border-foreground-100 mb-5"
          />

          {/* Configuración del circuito */}
          <div className="mb-4">
            <h3 className="font-semibold text-foreground-900 mb-1">Configuración del circuito</h3>
            <p className="text-sm text-foreground-700">{ruta.vueltas}</p>
            {ruta.detalleVueltas && (
              <p className="text-sm text-foreground-500 mt-1">{ruta.detalleVueltas}</p>
            )}
          </div>

          {/* Salida y llegada */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="border border-foreground-200 rounded-xl p-4">
              <p className="font-semibold text-primary-600 mb-1"><i className="ri-flag-line mr-1" />Salida</p>
              <p className="text-sm text-foreground-700">{ruta.salida}</p>
            </div>
            <div className="border border-foreground-200 rounded-xl p-4">
              <p className="font-semibold text-primary-600 mb-1"><i className="ri-flag-2-line mr-1" />Llegada</p>
              <p className="text-sm text-foreground-700">{ruta.llegada}</p>
            </div>
          </div>
        </section>

        {/* Certificado oficial */}
        <section className={cardClass}>
          <h3 className="font-semibold text-foreground-900 mb-3">
            Certificado oficial de medición · {ruta.certificado}
          </h3>
          <img
            src={ruta.certificadoImg}
            alt={`Certificado ${ruta.nombre}`}
            className="w-full rounded-xl border border-foreground-100"
          />
          <p className="text-xs text-foreground-500 mt-2">
            Medido por Hernán Mantilla · World Athletics – AIMS Grado A · válido hasta el 31 de diciembre de 2030.
          </p>
        </section>

        <div className="text-center">
          <Link
            to="/inscribirse"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors"
          >
            INSCRIBIRME
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </main>
    </div>
  );
}
